import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IVariablesClient, VariablesClient } from "app/ApiClient";
import { LoadingState } from "types";
import { initialStackablesState } from "./stackablesState";

const variablesClient: IVariablesClient = new VariablesClient(process.env.REACT_APP_API_URL);

export const getStackables = createAsyncThunk(
  "stackables/getStackables",
  async ({ projectId, versionId, assigner }: { projectId: number; versionId: string; assigner: string }, { rejectWithValue }) => {
    try {
      const result = await variablesClient.getStackables(projectId, versionId, assigner);
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const stackablesSlice = createSlice({
  name: "stackables",
  initialState: initialStackablesState,
  reducers: {
    resetStackables: () => initialStackablesState,
  },
  extraReducers: (builder) => {
    // getStackables
    builder.addCase(getStackables.pending, (state) => {
      state.stackables = null;
      state.loading = LoadingState.pending;
    });
    builder.addCase(getStackables.fulfilled, (state, { payload }) => {
      state.stackables = payload;
      state.loading = LoadingState.succeed;
    });
    builder.addCase(getStackables.rejected, (state) => {
      state.stackables = null;
      state.loading = LoadingState.failed;
    });
  },
});
export const { resetStackables } = stackablesSlice.actions;
export default stackablesSlice.reducer;
